import Panel from './panel';

export default class MobileFirstPanel extends Panel {}
